module.exports = __webpack_public_path__ + "img/icon_nfplus.9bb9da75.png";